<template lang="pug">
    .play-box(:class="{'revived-numbers-game-container_before-start': gameFinished , 'play-box--warning': isNeedRotate}")
        .warning(v-if="isNeedRotate")
            template
                svg#rotate(
                    version='1.1',
                    xmlns='http://www.w3.org/2000/svg',
                    x='0px', y='0px', width='40px', height='40px',
                    viewBox='0 0 612 612',
                    style='enable-background:new 0 0 612 612;',
                    xml:space='preserve'
                )
                    rotation-icon
                div
                    | {{ $i18n.t('map.map_mobile_rotateText') }}
        template(v-else)
            template(v-if='!isLoading')
                game-header(
                    :time='getTime'
                    :slug='type'
                    :game-type='parameters && parameters.courseType'
                    @soundStateChanged="headerKey = !headerKey",
                    :key="headerKey",
                    :is-homework="!!exerciseId"
                )
                .revived-numbers-game-container__result-container(v-if='!gameFinished')
                    answer-container(
                        :group-images="groupImages"
                        :amount-of-numbers="amountOfNumbers"
                        :step-of-images-shown="selectedItemIndex"
                        :check-answer="checkAnswer"
                        :revived-numbers-cells='revivedNumbersCells'
                        :all-items-selected="allItemsSelected"
                        :selected-images="selectedImages"
                        :second-chance="secondChance"
                        :filteredImages="filteredImages"
                        @setAssociation="setAssociation"
                        @setNumber="setNumber"
                    )
                    cs-button.revived-numbers__button(
                            v-if='isAllItemSet && !gameStarted'
                            color="blue"
                            @click='startGame'
                    ) {{ $i18n.t('trainer.trainer_gamePlayBox_play') }}
                    cs-button.revived-numbers__button(
                        v-if='checkAnswer'
                        color="blue"
                        @click='checkAnswers'
                    ) {{ $i18n.t('common.common_button_done') }}
                fireworks(v-if='gameFinished && isFireworksToShow' :is-mobile='isMobile')
                .revived-numbers-game-container__result-container(
                    v-if='gameFinished'
                )
                    .play-box__reaction-container
                        .play-box__reaction
                            .play-box__reaction-side.play-box__reaction-side--correct
                                span
                                    | {{ $i18n.t('trainer.trainer_game_wordField_yourTime')}}
                                span.play-box__reaction-count
                                    | {{ timeExecutionString }}
                            result-image.play-box__image(:status="isPassedSuccessfully ?  'success' : 'failure'")
                            .play-box__reaction-side.play-box__reaction-side--correct
                                span
                                    | {{ $i18n.t('trainer.trainer_gameFormSettingValue_opened')}}
                                span.play-box__reaction-count
                                    |   {{ answers.good }} / {{ amountOfNumbers }}
                    result-buttons(
                        :exercise-id="exerciseId"
                        games-type="memoryDevelopment"
                        show-restart-button
                        @restartGame="restartGame"
                        )
            cs-loader(v-else='')
</template>

<script>
    import RevivedNumbersGameItemsApi from '../../../../api/games/revivedNumbersGameItemsApi';
    import { shuffle, cloneDeep } from 'lodash';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import AnswerContainer from './AnswerContainer.vue';
    import MobileDetect from 'mobile-detect';

    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA() {
        return {
            hideGameHeader: false,
            prepareForGame: true,
            amountOfNumbers: 0,
            amountOfOpenedFields: 0,
            repeatedNumbers: 0,
            revivedNumbersCells: null,
            amountOfImagesCells: null,
            images: [],
            selectedItemIndex: 0,
            correctAnswers: [],
            allItemsSelected: false,
            selectedImagesIds: [],
            selectedImageIndex: 0,
            checkAnswer: false,
            answers: {
                good: 0,
                bad: 0,
            },
            filteredImages: null,
            secondChance: false,
            secondChanceCount: 0,
            groupImages: [],
            numberOfIterationsForCreatingGroupedArray: 0,
            savedTime: 0,
        };
    }

    export default {
        mixins: [playBoxGameMixin],
        data() {
            return DEFAULT_DATA();
        },
        mounted() {
            this.isTablet = Boolean(new MobileDetect(window.navigator.userAgent).tablet());
        },
        watch: {
            isNeedRotate(val) {
                if (val) {
                    this.savedTime = this.time;
                } else {
                    !this.timer && this.setTimer();
                    this.time = this.savedTime;
                }
            },
        },
        methods: {
            checkAnswers() {
                this.filteredImages?.forEach((item, index) => {
                    if (item.digit === this.correctAnswers[index].digit) {
                        item.correct = true;
                        item.type = 'digit';
                        item.empty = false;
                    } else {
                        item.correct = false;
                        item.type = 'images';
                        item.empty = false;
                    }
                    if (item.correct) {
                        this.answers.good++;
                    } else {
                        this.answers.bad++;
                    }
                });
                if (this.answers.good === this.filteredImages.length || this.secondChanceCount > 0) {
                    this.gameDone();
                }
                if (this.answers.bad > 0 && this.secondChanceCount === 0) {
                    this.secondChanceCount++;
                    this.answers.good = 0;
                    this.filteredImages[this.indexForCorrectElement].active = true;
                }
                this.checkAnswer = false;
                this.secondChance = true;
            },
            setAssociation(item) {
                this.$set(this.revivedNumbersCells, this.selectedItemIndex, {
                    ...this.revivedNumbersCells[this.selectedItemIndex],
                    image: item.value,
                    type: 'images',
                    imageId: item.id,
                });
                this.selectedImagesIds.push(item.id);
                this.selectedImages[this.selectedItemIndex].digit = this.revivedNumbersCells[
                    this.selectedItemIndex
                ].digit;
                this.revivedNumbersCells[this.selectedItemIndex].active = false;
                this.selectedItemIndex++;
                if (this.selectedItemIndex > this.amountOfNumbers - 1) {
                    this.selectedImages[this.selectedImageIndex].active = true;
                } else {
                    this.revivedNumbersCells[this.selectedItemIndex].active = true;
                }
            },
            setNumber(item) {
                if (!this.secondChance) {
                    this.$set(this.filteredImages, this.selectedImageIndex, {
                        ...this.filteredImages[this.selectedImageIndex],
                        digit: item.digit,
                        type: 'digit',
                        active: false,
                    });
                    this.selectedImageIndex++;
                    if (this.selectedImageIndex < this.amountOfNumbers) {
                        this.filteredImages[this.selectedImageIndex].active = true;
                    }
                    if (this.selectedImageIndex === this.amountOfNumbers) {
                        this.checkAnswer = true;
                    }
                } else {
                    let firstIndexToFind = this.filteredImages.findIndex(item => !item.correct);
                    this.$set(this.filteredImages, firstIndexToFind, {
                        ...this.filteredImages[firstIndexToFind],
                        digit: item.digit,
                        type: 'digit',
                        active: false,
                        correct: true,
                    });
                    if (this.correctAnswers?.length === this.filteredImages.filter(item => item.correct).length) {
                        this.checkAnswer = true;
                    } else {
                        let secondIndexToFind = this.filteredImages.findIndex(item => !item.correct);
                        this.filteredImages[secondIndexToFind].active = true;
                    }
                }
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        this.assignDataFromParameters();

                        this.$createjs.Sound.removeAllSounds();
                        this.$createjs.Sound.removeAllEventListeners();
                        this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                        this.$createjs.Sound.registerSounds(this.soundObjects);

                        this.getAmountOfRevivedNumbers();
                        this.getExample();
                    })
                    .catch(() => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            getAmountOfRevivedNumbers() {
                let num = 0;
                let amountOfNumbersArray = [];
                let maxAmountOfCells = this.amountOfNumbers - this.repeatedNumbers;
                for (let i = 0; i < maxAmountOfCells; i++) {
                    num = this.generateRandomNumberInAllowedRange(0, 10);
                    while (amountOfNumbersArray.includes(num)) {
                        num = this.generateRandomNumberInAllowedRange(0, 10);
                    }
                    amountOfNumbersArray.push(num);
                }
                let amountOfRepeatedNumbersArray = [];
                for (let i = 0; i < this.repeatedNumbers; i++) {
                    let number = amountOfNumbersArray[Math.floor(Math.random() * amountOfNumbersArray.length)];
                    while (amountOfRepeatedNumbersArray.includes(number)) {
                        number = amountOfNumbersArray[Math.floor(Math.random() * amountOfNumbersArray.length)];
                    }
                    amountOfRepeatedNumbersArray.push(number);
                }
                this.revivedNumbersCells = amountOfNumbersArray.concat(amountOfRepeatedNumbersArray);
                this.revivedNumbersCells = shuffle(this.revivedNumbersCells);
                this.revivedNumbersCells = this.revivedNumbersCells.map(digit => {
                    return { digit: digit, image: null, active: null, type: null };
                });
                this.revivedNumbersCells[this.selectedItemIndex].active = true;
            },
            generateRandomNumberInAllowedRange(minValue, maxValue) {
                return Math.floor(Math.random() * (maxValue - minValue) + minValue);
            },
            assignDataFromParameters() {
                this.amountOfNumbers = this.parameters.amountOfNumbers;
                this.amountOfOpenedFields = this.parameters.amountOfOpenedFields;
                this.repeatedNumbers = this.parameters.repeatedNumbers;
            },
            getExample() {
                this.isLoading = true;
                RevivedNumbersGameItemsApi.getRevivedNumbersByRequest()
                    .then(data => {
                        this.images = data.images;
                        this.images = this.images.map(({ value, type, id, group }) => {
                            return {
                                value,
                                type,
                                id,
                                active: false,
                                digit: null,
                                empty: false,
                                imageGroupNumber: group,
                            };
                        });
                        this.groupImageByNumber();
                        this.isLoading = false;
                        !this.isNeedRotate && this.setTimer();
                    })
                    .catch(err => this.showErrorMessage(err));
            },
            groupImageByNumber() {
                let arrayOfNumberForFindImagesGroup = [];
                for (let i = 0; i < this.revivedNumbersCells.length; i++) {
                    let numberForFindImageGroup = this.revivedNumbersCells[i].digit;
                    if (arrayOfNumberForFindImagesGroup.includes(numberForFindImageGroup)) {
                        this.numberOfIterationsForCreatingGroupedArray = 6;
                    } else {
                        this.numberOfIterationsForCreatingGroupedArray = 3;
                    }
                    arrayOfNumberForFindImagesGroup.push(numberForFindImageGroup);
                    let filteredImages = this.images.filter(item => item.imageGroupNumber === numberForFindImageGroup);
                    for (let i = 0; i < this.numberOfIterationsForCreatingGroupedArray; i++) {
                        if (!this.groupImages.includes(filteredImages[i])) {
                            this.groupImages.push(filteredImages[i]);
                        }
                    }
                }
            },
            refreshGameStatBeforeSend() {
                this.gameStat.attempts = this.secondChanceCount;
                this.gameStat.answers = this.answers.good;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            calculatePercent() {
                let total = this.amountOfNumbers;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            resetData() {
                this.hideGameHeader = false;
                this.gameStarted = false;
                this.stopTimer();
                this.timer = null;
                this.itemsForAnswersBox = [];
                if (this.answerTimer) {
                    clearInterval(this.answerTimer);
                    this.answerTimer = null;
                }
            },
            gameDone() {
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play('gameDone');
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                this.gameFinished = true;
                this.sendStat();
            },
            startGame() {
                this.stopTimer();
                this.correctAnswers = cloneDeep(this.selectedImages);
                this.filteredImages = cloneDeep(this.selectedImages);
                this.filteredImages = this.getImagesWithOpenedFields(this.filteredImages);
                this.allItemsSelected = true;
                this.gameStarted = true;
            },
            beforeGameRestart() {
                this.resetData();
                Object.assign(this, DEFAULT_DATA());
            },
            getImagesWithOpenedFields(selectedImages) {
                const images = cloneDeep(selectedImages);
                let amountOfOpenedFields = this.amountOfNumbers - this.amountOfOpenedFields;

                while (amountOfOpenedFields > 0) {
                    let indexToOpen = _.random(0, images.length - 1);
                    while (images[indexToOpen].empty) {
                        indexToOpen = _.random(0, images.length - 1);
                    }
                    images[indexToOpen].empty = true;
                    images[indexToOpen].type = 'empty';
                    amountOfOpenedFields--;
                }
                return images;
            },
        },
        computed: {
            isNeedRotate() {
                return this.isVerticalScreen && this.windowWidth <= 992;
            },
            isPassedSuccessfully() {
                return this.answers.good > Math.floor(this.amountOfNumbers / 2);
            },
            isFireworksToShow() {
                return this.answers.good === this.amountOfNumbers;
            },
            timeExecutionString() {
                return this.time + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', this.time);
            },
            selectedImages() {
                return this.groupImages.filter(image => this.selectedImagesIds.includes(image.id));
            },
            indexForCorrectElement() {
                return this.filteredImages.findIndex(item => !item.correct);
            },
            isAllItemSet() {
                return this.selectedImagesIds.length === this.amountOfNumbers;
            },
        },
        components: {
            AnswerContainer,
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';

    .play-box--warning {
        display: table;
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .revived-numbers-game-container__result-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
    }
    .revived-numbers-game-container_before-start {
        justify-content: space-around;
    }

    .revived-numbers-game-container__result-image {
        @include stack-space($space-base);
    }

    .revived-numbers-game-container__interactive-place {
        margin: 0;
        flex: 1 1 auto;
        width: 100%;
        min-height: 100%;
        display: inline-flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .revived-numbers__buttons-container {
        display: flex;
        justify-content: center;
        text-align: center;
        margin: 40px 0;
    }

    .revived-numbers__answer-container {
        display: flex;
        justify-content: center;
        flex: 1 1 auto;
        width: 100%;
    }

    .revived-numbers__link {
        @media screen and (max-width: 640px) {
            display: block;
            margin-bottom: 30px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .revived-numbers__button {
        @media screen and (max-width: 640px) {
        }
    }

    .play-box {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

    .play-box__time {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: $hsl-color-green-58;
        margin-bottom: 30px;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        max-height: 340px;
        order: 2;
        @include media($md) {
            order: initial;
            margin-bottom: 40px;
            max-height: 460px;
        }
    }

    .play-box__reaction {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: nowrap;
        width: 100%;
        flex-direction: column-reverse;
        @include media($md) {
            flex-direction: row;
            justify-content: center;
        }
    }

    .play-box__reaction-side {
        font-weight: 500;
        font-size: 20px;
        margin-bottom: 10px;
        @include media($sm) {
            display: flex;
            flex-direction: row;
            justify-content: center;
            height: 100%;
            flex-grow: 1;
            align-self: center;
            width: auto;
            font-size: 20px;
            margin-bottom: 20px;
        }
        @include media($md) {
            flex-direction: column;
        }
        @media screen and ($md) and (max-width: 800px) {
            font-size: 18px;
        }
        @include media($lg) {
            font-size: 32px;
        }
        @include media($xlg) {
            font-size: 42px;
        }
        color: $hsl-color-green-58;
    }

    .play-box__reaction-count {
        margin-left: 5px;
        @include media($md) {
            margin: 0;
        }
    }

    .play-box__reaction-side--correct {
        color: $hsl-color-green-58;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
